import { FormInstance } from 'antd';
import moment from 'moment';

export function validateDateNotInPast(form: FormInstance, fieldName: string) {
  return (_, value: moment.Moment) => {
    if (!form.isFieldTouched(fieldName)) {
      return Promise.resolve();
    }

    if (!value) {
      return Promise.reject(new Error('Please select a start date'));
    }

    if (value.isBefore(moment().startOf('day'))) {
      return Promise.reject(new Error('Start date cannot be in the past'));
    }

    return Promise.resolve();
  };
}
